export default "__VITE_ASSET__R28r$uyR__"